export function serialize (obj = null) {
  let string = ''
  if (obj) {
    Object.keys(obj).forEach(x => {
      if (obj[x]) {
        if (Array.isArray(obj[x])) {
          obj[x].forEach(value => {
            if (value.toISOString) string += `&${x}[]=${encodeURIComponent(value.toISOString())}`
            else string += `&${x}[]=${encodeURIComponent(value)}`
          })
        } else {
          if (obj[x].toISOString) string += `&${x}=${encodeURIComponent(obj[x].toISOString())}`
          else string += `&${x}=${encodeURIComponent(obj[x])}`
        }
      }
    })
  }
  return string.substr(1)
}

export function serialize2 (obj = null, sub = false, index, key = 0) {
  let string = ''
  if (obj) {
    for (const idx in obj) {
      if (obj[idx] === null) continue
      if (isNaN(obj[idx]) && typeof obj[idx] === 'undefined') continue
      if (Array.isArray(obj[idx])) {
        obj[idx].forEach((v, k) => {
          string += serialize2(v, true, idx, k)
        })
      } else {
        if (!sub) {
          if (obj[idx] === null) continue
          if (obj[idx].toISOString) {
            string += `&${idx}=${encodeURIComponent(obj[idx].toISOString())}`
          } else {
            string += `&${idx}=${encodeURIComponent(obj[idx])}`
          }
        } else {
          if (obj[idx].toISOString) {
            string += `&${index}[${key}][${idx}]=${encodeURIComponent(obj[idx].toISOString())}`
          } else {
            string += `&${index}[${key}][${idx}]=${encodeURIComponent(obj[idx])}`
          }
        }
      }
    }
  }
  return string
}
